import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useApp } from "../app/AppContext.jsx";
import { COUNTRIES, LANGS } from "../i18n/index.js";

export default function TopBar() {
  const { t, country, setCountry, lang, setLang, countryMeta, user, signOut, authReady } = useApp();
  const [open, setOpen] = useState(false);

  const link = ({ isActive }) => (isActive ? "is-active" : undefined);

  return (
    <header className="topbar">
      <Link to="/" className="topbar__logo" onClick={() => setOpen(false)}>
        APEX<span>CARS</span>
      </Link>

      <nav id="main-nav" className={`topbar__nav${open ? " is-open" : ""}`} onClick={() => setOpen(false)}>
        <NavLink to="/stock" className={link}>{t("nav.stock")}</NavLink>
        <NavLink to="/auctions" className={link}>{t("nav.auctions")}</NavLink>
        <NavLink to="/import-calculator" className={link}>{t("nav.calculator")}</NavLink>
        <NavLink to="/how-it-works" className={link}>{t("nav.how")}</NavLink>
        <NavLink to="/wanted" className={link}>{t("nav.contact")}</NavLink>
      </nav>

      <div className="topbar__right">
        <div className="pickers">
          {/* Country drives every price on the site, so it sits in the chrome rather than
              in a filter panel. */}
          <label className="picker" title={t("calc.destination")}>
            <span className="picker__flag">{countryMeta.flag}</span>
            <select value={country} onChange={(e) => setCountry(e.target.value)} aria-label={t("calc.destination")}>
              {COUNTRIES.map((c) => (
                <option key={c.code} value={c.code}>{c.code}</option>
              ))}
            </select>
          </label>

          <label className="picker">
            <select value={lang} onChange={(e) => setLang(e.target.value)} aria-label={t("common.language")}>
              {LANGS.map((l) => (
                <option key={l.code} value={l.code}>{l.label}</option>
              ))}
            </select>
          </label>
        </div>

        {/* Nothing until the session is known: a "Sign in" that flickers into an email
            address reads as having been logged out and back in again. */}
        {authReady && (user ? (
          <button className="topbar__account" onClick={signOut} title={user.email}>
            <span className="topbar__email">{user.email}</span>
            <span className="tiny muted">{t("auth.signOut")}</span>
          </button>
        ) : (
          <Link to="/signin" className="btn btn--sm">{t("auth.signIn")}</Link>
        ))}

        <button className="topbar__burger" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-label={t("common.menu")} aria-controls="main-nav">
          ☰
        </button>
      </div>
    </header>
  );
}
